import { render } from "./tree-selector.vue?vue&type=template&id=458fdf06"
import script from "./tree-selector.vue?vue&type=script&lang=js"
export * from "./tree-selector.vue?vue&type=script&lang=js"

import "./tree-selector.vue?vue&type=style&index=0&id=458fdf06&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__